'use strict';

// import Swiper Styles
import 'swiper/css/bundle';
// import Swiper
import Swiper, {
  SwiperOptions,
  Navigation,
  Scrollbar,
  Autoplay,
  EffectFade,
  Pagination,
} from 'swiper';
// Enable Swiper Modules
Swiper.use([Scrollbar, Navigation, Autoplay, EffectFade, Pagination]);

const swiperParams: SwiperOptions = {
  slidesPerView: 'auto',
  spaceBetween: 28,
  grabCursor: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    992: {
      spaceBetween: 33,
    },
  },
};

const swiperParamsFP: SwiperOptions = {
  slidesPerView: 'auto',
  spaceBetween: 28,
  grabCursor: true,
  navigation: {
    nextEl: '.frontPagePlan-next',
    prevEl: '.frontPagePlan-prev',
  },
  pagination: {
    el: '.frontPagePlan-pagination',
    clickable: true,
  },
  breakpoints: {
    992: {
      slidesPerView: 4,
      spaceBetween: 44,
      // loop: true,
    },
  },
};

const swiperParamsFBF: SwiperOptions = {
  slidesPerView: 'auto',
  spaceBetween: 28,
  grabCursor: true,
  navigation: {
    nextEl: '.frontPageBridal-next',
    prevEl: '.frontPageBridal-prev',
  },
  breakpoints: {
    992: {
      slidesPerView: 4,
      spaceBetween: 44,
    },
  },
};

const swiperParamsFair: SwiperOptions = {
  slidesPerView: 1,
  grabCursor: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  breakpoints: {
    992: {
      slidesPerView: 3,
      spaceBetween: 24,
      loop: true,
    },
    1200: {
      slidesPerView: 4,
      spaceBetween: 44,
      loop: true,
    },
  },
};

const swiperParamsFood: SwiperOptions = {
  slidesPerView: 1,
  spaceBetween: 16,
  centeredSlides: true,
  grabCursor: true,
  loop: true,
  loopAdditionalSlides: 1,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  breakpoints: {
    768: {
      slidesPerView: 1.75,
      spaceBetween: 54,
    },
  },
};

const swiperParamsFB: SwiperOptions = {
  slidesPerView: 1,
  spaceBetween: 5,
  centeredSlides: true,
  grabCursor: true,
  loop: true,
  loopAdditionalSlides: 1,
  navigation: {
    nextEl: '.banquet-next',
    prevEl: '.banquet-prev',
  },
  pagination: {
    el: '.banquet-pagination',
    clickable: true,
  },
  speed: 1000,
  autoplay: {
    delay: 4000,
  },
  breakpoints: {
    992: {
      centeredSlides: true,
      slidesPerView: 1.88,
      spaceBetween: 3,
    },
  },
};

const swiperParamsBanquet: SwiperOptions = {
  slidesPerView: 1,
  grabCursor: true,
  effect: 'fade',
  loop: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  breakpoints: {
    768: {
      centeredSlides: true,
    },
  },
};

const swiperParamsReport: SwiperOptions = {
  slidesPerView: 1,
  spaceBetween: 28,
  grabCursor: true,
  centeredSlides: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    576: {
      centeredSlides: false,
      slidesPerView: 2,
      spaceBetween: 40,
      loop: true,
    },
    800: {
      centeredSlides: false,
      slidesPerView: 3,
      spaceBetween: 64,
      loop: true,
    },
  },
};

const initSwiper = () => {
  const initSwiperIfSlidesExist = (selector: string, params: SwiperOptions) => {
    const containers = document.querySelectorAll(
      selector
    ) as NodeListOf<HTMLElement>;
    containers.forEach((container) => {
      const slides = container.querySelectorAll('.swiper-slide');
      const parent = container.parentElement as HTMLElement;
      const controller = parent.querySelector(
        '.swiper-controller'
      ) as HTMLElement;
      // スライドが存在しない、または1枚または0枚の場合、.swiper-controllerを非表示にする
      if (!slides || slides.length <= 1) {
        if (controller) {
          controller.style.display = 'none';
        }
      } else {
        new Swiper(container, params);
        if (controller) {
          controller.style.display = 'block';
        }
      }
    });
  };

  initSwiperIfSlidesExist(
    '.pageFootBridalSlider > .pageBridalSwiper',
    swiperParams
  );
  initSwiperIfSlidesExist(
    '.frontPagePlanSlider > .pageBridalSwiper',
    swiperParamsFP
  );
  initSwiperIfSlidesExist(
    '.frontPageBridalSlider > .pageBridalSwiper',
    swiperParamsFBF
  );
  initSwiperIfSlidesExist('.pageFairIntroSwiper', swiperParamsFair);
  initSwiperIfSlidesExist('.singleReportOtherSwiper', swiperParamsReport);
  initSwiperIfSlidesExist('.tempFoodMenuSwiper', swiperParamsFood);
  initSwiperIfSlidesExist('.tempVenueCeremonySwiper', swiperParamsFood);
  initSwiperIfSlidesExist('.frontPageBanquetSwiper', swiperParamsFB);
  initSwiperIfSlidesExist('.tempVenueBanquetSwiper', swiperParamsBanquet);
};

window.addEventListener('DOMContentLoaded', () => {
  initSwiper();
});
